export const MAX_TAMANO_PDF_BYTES = 5 * 1000 * 1000;

export const formatoMB = (bytes) => {
  const mb = bytes / (1000 * 1000);
  return `${Number.isInteger(mb) ? mb : mb.toFixed(1)} MB`;
};